export default __webpack_public_path__ + "media/images/opa-logo-0a2ebf6050e3d50246e466ab8759fc88.png";